import {APIEndpoint, getToken} from "./auth.service";
import {cz_script_objects, pathRoutes} from "../props/util.props";
import axios from "axios";
import {v4 as uuidv4} from "uuid";


export const getAuthorization = () => {
  let token = getToken();
  let authorization = "Bearer " + token;

  return authorization;
};
export const checkEmpty = (val: any) => {
  if (
    val === undefined ||
    val === null ||
    val === "null" ||
    val === "undefined"
  )
    return true;
  if (val.length === 0) return true;

  return false;
};

export function parseJwt(token: any) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}
export const isTrue = (val: any) => {
  if (val === true || val === "true" || val === "y"|| val === "Y") return true;
  else return false;
};

export const getnameOfUser = (userdata: any) => {
  let res = userdata.username;
  if (!checkEmpty(userdata.firstname)) {
    res = userdata.firstname;
    if (!checkEmpty(userdata.lastname)) {
      res = userdata.firstname + " " + userdata.lastname;
    }
  }
  return res;
};

export const getUserID = (userdata: any) => {
  console.log("User ID, ", userdata.userID);
  return userdata.userID;
};

export async function getUrlBlob(url: any) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = function (e) {
      var arrayBufferView = new Uint8Array(this.response);
      var blob = new Blob([arrayBufferView]);
      var urlCreator = window.URL || window.webkitURL;
      let urlT = urlCreator.createObjectURL(blob);
      if (checkEmpty(urlT)) {
        resolve(url);
      } else {
        resolve(urlT);
      }
    };
    xhr.addEventListener("error", function () {
      resolve(url);
    });
    xhr.send();
  });
}

export const getUrlHttp = (url: any) => {
  try {
    if (isTrue(window.__RUNTIME_CONFIG__.REACT_APP_EDIT_URL)) {
      url = url.replace(
        "https://10.1.102.34/centre",
        "http://10.1.102.34:5552"
      );
    }
    return url;
  } catch (e) {
    return url;
  }
};

export const checkMobile = () => {
  return window.innerWidth <= 768;
};

export const isCommunity = () => {
  if (window.location.href.indexOf(pathRoutes.groupCommunity) != -1) {
    return true;
  }
  return false;
};

export function logout(deviceID = null) {
  const token = getToken();
  axios.post(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Logout,
      {
        deviceID: deviceID || "web",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
  ).then(res => res.data);
  // try {
  //   let data = await axios.post(
  //     window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Logout,
  //     {
  //       deviceID: deviceID || "web",
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );
  //   return data;
  // } catch (e) {
  //   console.error("[LOGOUTERRPR]", e);
  //   return;
  // }
}

export function logoutCenter() {
  const token = getToken();
  return axios.post(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.Logout,
      {
        deviceID: "web",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
  ).then(res => res.data);
}

export function getPathWss(path: any) {
  if (path?.startsWith("ws")) {
    return path;
  }
  var loc = window.location,
    new_uri;
  if (loc.protocol === "https:") {
    new_uri = "wss:";
  } else {
    new_uri = "ws:";
  }
  new_uri += "//" + loc.host;
  new_uri += path;
  return new_uri;
}

export function getUrlParameter(sParam: any, url: any) {
  try {
    var temp = url.split("?")[1];
    var sPageURL = ("?" + temp).substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return null;
  } catch (e) {
    return null;
  }
}

export function saveFileJsToLocal(result: any, key: any) {
  // var fileReader = new FileReader();

  // fileReader.onload = function (evt: any) {
  //   var result = evt.target.result;

  //   try {

  //   } catch (e) {
  //     console.log("Storage failed: " + e);
  //   }
  // };

  // fileReader.readAsDataURL(file);
  sessionStorage.setItem(key, result);
}
export function getFileJSFromLocal(key: any) {
  return sessionStorage.getItem(key);
}

export function loadCitizenJsToSessionStorage() {
  for (let a = 0; a < cz_script_objects.length; a++) {
    let cz_script_object = cz_script_objects[a];
    let script = getFileJSFromLocal(cz_script_object.key);
    if (checkEmpty(script)) {
      // var settings = {
      //   url: cz_script_object.url,
      //   method: "GET",
      //   timeout: 0,
      // };

      // $.ajax({
      //   url: cz_script_object.url,
      //   dataType: "script",
      // }).done(function (response) {
      //   // console.log("response==>", response);
      //   saveFileJsToLocal(response, cz_script_object.key);
      // });

      const options = {
        headers: {
          // Authorization: authHeader
        },
      };
      fetch(cz_script_object.url, options)
        .then((res) => {
          var response: any = null;

          if (res.status === 200) {
            response = res.blob();
            console.log("res===> 200 ", res);
          }

          return response;
        })
        .then(async (blob) => {
          var file = "";
          if (checkEmpty(blob)) {
            file = "";
          } else {
            file = await blob.text();
          }
          // console.log("response==>", file);
          saveFileJsToLocal(file, cz_script_object.key);
        });
    }
  }
}

export function getSetCokieLogin() {
  let hash; // = uuidv4();
  hash = getCookie("hash");
  // console.log("hash : "+hash);
  if (checkEmpty(hash)) {
    hash = uuidv4();
  }
  
  setCookie("hash", hash, 30);
  hash = getCookie("hash");
  return hash;
}

export function setCookie(cName: any, cValue: any, expDays: any) {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
export function getCookie(cName: any) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}

export  const getNameProfile = (firstname: any,lastname: any) => {
  return (firstname ? firstname : "") + " " + (lastname ? lastname : "") ;  
 }


 export const getTaskMember = () => {
  const url: any = window.__RUNTIME_CONFIG__.REACT_APP_CM_EXECUTE_SERVICE + `/api/v1/task/member`;
  axios
    .get(url, {
      headers: { 
        Authorization: `Bearer ${getToken()}` 
      },
    })
    .then((res: any) => {
      console.log("task_member : ", res);
      if (res.status === 200) {
        const memberList = res?.data?.responseObjectsMap?.obj_member_Out?.data;
        let taskMember = memberList.filter((elem: any, index: any) => memberList.findIndex((obj: any) => obj.user_name === elem.user_name) === index)
        
        // let data = JSON.stringify(res?.data?.responseObjectsMap?.obj_member_Out?.data);
        // sessionStorage.setItem("task_member", data);
        sessionStorage.setItem("task_member",JSON.stringify(taskMember))
      } 
    })
    .catch((error)=>{
      // alert(error);
    })
  let task_member = sessionStorage.getItem("task_member")
  if (task_member !== null || task_member !== undefined) {
    return true;
  } else {
    return false;
  }
}

export const getUtilDepartments = async () => {

  return new Promise((resolve,reject)=>{

    const url: any = window.__RUNTIME_CONFIG__.REACT_APP_CM_EXECUTE_SERVICE + `/api/v1/task/my-work-groups`;
    axios
      .get(url, {
        headers: { 
          Authorization: `Bearer ${getToken()}` 
        },
      })
      .then((res: any) => {
        if (res.status === 200) {
          const taskDepartment = res?.groups;
          // sessionStorage.setItem(
          //   "task_department",
          //   JSON.stringify(taskDepartment)
          // );
          resolve(taskDepartment)
        } 
      })
      .catch((error)=>{
        // alert(error);
        resolve([])
      })
    // let taskDepartment = sessionStorage.getItem("task_department")
    // if (taskDepartment !== null || taskDepartment !== undefined) {
    //   return true;
    // } else {
    //   return false;
    // }
    
  })
  
};

export const getGotos=(gotoData:any,t:any) => {
  let gotos = gotoData;
  if(!checkEmpty(gotos)){
      let done = gotos.find((e:any)=>{
          return e?.id == "END"
      })
      let cancel = gotos.find((e:any)=>{
          return e?.id == "CANCEL"
      })
      if(checkEmpty(done)){
          let doneObject = {id:"END",stepName:t("End Workflow")}
          gotos.push(doneObject);
      }
      if(checkEmpty(cancel)){
          let cancelObject = {id:"CANCEL",stepName:t("Cancel Workflow")}
          gotos.push(cancelObject);
      }          
  }
  return gotos
}

export const getnewUrl = (url: any,instance:any) => {

  const myRe = new RegExp(/={+(\w)+}/g, 'g');
  const myRe2 = new RegExp(/={+(\w)+\.+(\w)+}/g, 'g');

  let rpArr;
  let newUrl = url;
  while ((rpArr = myRe.exec(newUrl)) !== null) {
    let index = myRe.lastIndex - rpArr[0].length
    let objectName = rpArr[0].replace('={', '').replace('}', '')
    if (objectName === "instanceId") {
      objectName = "id"
    }
    let replacement = instance[objectName];

    let token = getToken()
    if (objectName === "token") {
      replacement = token;
    }

    newUrl = newUrl.substring(0, index) + "=" + replacement + newUrl.substring(myRe.lastIndex);
  }
  while ((rpArr = myRe2.exec(newUrl)) !== null) {
    let index = myRe2.lastIndex - rpArr[0].length
    let replacement = rpArr[0].replace('={', '').replace('}', '')
    let newReplacement = replacement.split(".")
    let rp = instance[newReplacement[0]][newReplacement[1]]

    // console.log(`Found ${rpArr[0]}. Starts at ${myRe.lastIndex - rpArr[0].length}. Next starts at ${myRe.lastIndex}.`);
    newUrl = newUrl.substring(0, index) + "=" + rp + newUrl.substring(myRe2.lastIndex);
  }
  console.log("newUrl", newUrl)
  return newUrl;
}

export function updateQueryStringParameter(uri:any, key:any, value:any) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}